import React from 'react';
import MeetingsTabs from './MeetingsTabs';
import ScreenTitle from '../../../../elements/ScreenTitle/ScreenTitle';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useEvent } from '../../../../../data/hooks/eventHooks';
import TopBarEvent from '../../../../elements/TopBar/TopBarEvent';
import TabDescription from './TabDescription';

function MeetingsScreenHeader(props) {
    const { eventId, meetingTab } = props,
        event = useEvent(eventId),
        i18n = useI18n()

    return (
        <>
            <TopBarEvent event={event}  returnURL="../.." />
            <ScreenTitle screen={i18n['label.event.title']} event={event} />
            <MeetingsTabs meetingTab={meetingTab} />
            <TabDescription meetingTab={meetingTab} />
        </>
    );
}

export default MeetingsScreenHeader;
